module.exports = __webpack_public_path__ + "static/open-sans-v27-latin-700-875ba54801f7cf83ea70abf613fab665.woff2";